// Upsell בתוך העגלה: לחיצה על כרטיס פותחת חלון בחירת מידה, ומשם מוסיפים לעגלה
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var modal, data, selectedId, lastFocus;

  function money(cents) {
    try {
      if (window.theme && theme.Currency && theme.settings && theme.settings.moneyFormat) {
        return theme.Currency.formatMoney(cents, theme.settings.moneyFormat).replace(/[.,]00(?!\d)/, '');
      }
    } catch (e) {}
    return '₪' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function addToCart(variantId) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return fetch(root + 'cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        // בונה מחדש את העגלה (הכובע שנוסף ייעלם מהשורה) ומעדכן את פס המשלוח החינם
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      });
  }

  function buildModal() {
    modal = document.createElement('div');
    modal.className = 'upsell-size-modal';
    modal.setAttribute('dir', 'rtl');
    modal.hidden = true;
    modal.innerHTML =
      '<div class="upsell-size-modal__overlay" data-close></div>' +
      '<div class="upsell-size-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="UpsellSizeTitle">' +
        '<button type="button" class="upsell-size-modal__close" data-close aria-label="סגירה">' +
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
        '</button>' +
        '<div class="upsell-size-modal__top">' +
          '<img class="upsell-size-modal__img" alt="">' +
          '<div>' +
            '<p class="upsell-size-modal__title" id="UpsellSizeTitle"></p>' +
            '<p class="upsell-size-modal__price"></p>' +
          '</div>' +
        '</div>' +
        '<div class="upsell-size-modal__options">' +
          '<p class="upsell-size-modal__label"></p>' +
          '<div class="upsell-size-modal__chips"></div>' +
        '</div>' +
        '<p class="upsell-size-modal__error" hidden>לא הצלחנו להוסיף את המוצר, נסי שוב</p>' +
        '<button type="button" class="upsell-size-modal__add">הוספה לסל</button>' +
      '</div>';
    document.body.appendChild(modal);

    // מונע מהעגלה הצדדית להיסגר כשלוחצים בתוך החלון
    modal.addEventListener('click', function (e) {
      e.stopPropagation();
      if (e.target.closest('[data-close]')) return close();
      var chip = e.target.closest('[data-variant]');
      if (chip && !chip.disabled) select(chip.dataset.variant);
    });
    modal.addEventListener('keyup', function (e) {
      if (e.key === 'Escape') { e.stopPropagation(); close(); }
    });
    modal.querySelector('.upsell-size-modal__add').addEventListener('click', function () {
      var btn = this;
      if (!selectedId) return;
      btn.classList.add('is-loading');
      btn.disabled = true;
      modal.querySelector('.upsell-size-modal__error').hidden = true;
      addToCart(selectedId)
        .then(close)
        .catch(function () { modal.querySelector('.upsell-size-modal__error').hidden = false; })
        .then(function () { btn.classList.remove('is-loading'); btn.disabled = false; });
    });
  }

  function select(id) {
    selectedId = id;
    var v = data.variants.filter(function (x) { return String(x.id) === String(id); })[0];
    modal.querySelectorAll('[data-variant]').forEach(function (c) {
      c.classList.toggle('is-selected', c.dataset.variant === String(id));
      c.setAttribute('aria-pressed', c.dataset.variant === String(id));
    });
    var price = modal.querySelector('.upsell-size-modal__price');
    price.innerHTML = (v.compare > v.price ? '<s>' + money(v.compare) + '</s> ' : '') + money(v.price);
  }

  function open(json) {
    if (!modal) buildModal();
    data = json;
    lastFocus = document.activeElement;
    var img = modal.querySelector('.upsell-size-modal__img');
    img.src = data.image || '';
    img.hidden = !data.image;
    modal.querySelector('.upsell-size-modal__title').textContent = data.title;
    modal.querySelector('.upsell-size-modal__label').textContent = (data.optionLabel || 'מידה') + ':';
    modal.querySelector('.upsell-size-modal__error').hidden = true;

    var chips = modal.querySelector('.upsell-size-modal__chips');
    chips.innerHTML = '';
    var first = null;
    data.variants.forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'upsell-size-modal__chip';
      b.textContent = v.title;
      b.dataset.variant = String(v.id);
      if (!v.available) { b.disabled = true; b.classList.add('is-soldout'); }
      else if (!first) first = v.id;
      chips.appendChild(b);
    });
    if (!first) return;
    select(first);

    modal.hidden = false;
    document.documentElement.classList.add('upsell-size-modal-open');
    requestAnimationFrame(function () { modal.classList.add('is-open'); });
    modal.querySelector('.upsell-size-modal__add').focus();
  }

  function close() {
    if (!modal || modal.hidden) return;
    modal.classList.remove('is-open');
    document.documentElement.classList.remove('upsell-size-modal-open');
    setTimeout(function () { modal.hidden = true; }, 200);
    if (lastFocus && document.body.contains(lastFocus)) lastFocus.focus();
  }

  // לחיצה על כרטיס בעגלה
  document.addEventListener('click', function (e) {
    var card = e.target.closest('[data-cart-upsell-open]');
    if (!card) return;
    e.preventDefault();
    e.stopPropagation();
    var wrap = card.closest('.cart-upsell-inline__card');
    var json;
    try { json = JSON.parse(wrap.querySelector('[data-cart-upsell-json]').textContent); } catch (err) { return; }

    // מוצר בלי מידות: מוסיפים ישר
    if (json.single) {
      card.classList.add('is-loading');
      addToCart(json.variants[0].id).catch(function () { card.classList.remove('is-loading'); });
      return;
    }
    open(json);
  });
})();
